import { APP_INITIALIZER, inject } from '@angular/core';
import { ConfigStateService, RoutesService } from '@abp/ng.core';
import { FLOWPAY_BASE_ROUTES } from './flowpay-base.routes';
import { addRoutesWhenAnyFeatureEnabled } from '../../shared/routes/feature-routes.util';

export const FLOWPAY_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);
  const configState = inject(ConfigStateService);

  return () => {
    addRoutesWhenAnyFeatureEnabled(
      routesService,
      configState,
      ['cargo_fleet.FlowPay'],
      [...FLOWPAY_BASE_ROUTES],
    );
  };
}
